import { Badge } from '@up2stay/up2promo-ui';
import { cn } from '@up2stay/up2promo-ui';
import { createElement } from 'react';

import { getProductTypeIcon } from './product-type-icon';

export type ProductTypeBadgeProps = {
  productType?: string;
  label: string;
  className?: string;
  /** Show type glyph inside the chip (default true). */
  showIcon?: boolean;
};

/**
 * Type chip via shared Badge secondary (muted fill + border + foreground ink).
 * Icons carry recognition; color stays reserved for health/live interrupts.
 */
export function ProductTypeBadge({
  productType,
  label,
  className,
  showIcon = true,
}: ProductTypeBadgeProps) {
  return (
    <Badge
      variant="secondary"
      className={cn('shrink-0 gap-1 font-medium', className)}
    >
      {showIcon
        ? createElement(getProductTypeIcon(productType), {
            className: 'size-3 shrink-0',
            'aria-hidden': true,
          })
        : null}
      {label}
    </Badge>
  );
}
